import React, { useContext, useEffect, useState } from "react";
import StoreContext from "./Store/Context";
import moment from "moment";
import { NavLink as RRNavLink, Outlet } from "react-router-dom";
import { NavItem, Label, Nav, NavLink, Col, Row, Container } from "reactstrap";
import {
  FACTORY_ICON,
  SETTING_IMAGE,
  INVENTARIO_IMAGE,
  ARTICULOS_IMAGE,
  CASH_REGISTER_IMAGE,
  COTIZACION_IMAGE,
  EXIT_IMAGE,
  REPORTE_IMAGE,
  CLIENTS_IMAGE,
  MONEY_PAY,
} from "./Image";
import { dataDropdownTipo, folios_restantes } from "./Services";

const Layout = ({ children }) => {
  const {
    token,
    cajaData,
    usr_key_login,
    dataCompania,
    usr_nombre,
    usr_perfil,
    usr_ajustes,
    usr_factura,
    usr_inventario,
    usr_cotizacion,
    usr_articulo,
    usr_reporte,
    usr_gastos,
    usr_clientes,
    quitToken,
  } = useContext(StoreContext);
  const [dataFolios, setDataFolios] = useState([]);
  var perfil = dataDropdownTipo.filter((data) => {
    if (data.value === usr_perfil) {
      return data.label;
    }
  });
  if (!token) {
    document.location.href = "/";
  }
  if (cajaData === undefined) {
    document.location.href = "/";
  }

  async function fetchFolios() {
    var response = await folios_restantes();
    setDataFolios(response.FoliosRestantesResult);
  }
  {moment(dataCompania.ini_fecha).format("YYYY-MM-DD")};
  useEffect(() => {
    fetchFolios()
  }, []);
  console.log(dataCompania.ini_fecha);
  if (token === "") {
    return null;
  } else {
    return (
      <React.Fragment>
        <Container fluid>
          <Row className="menu-color-nav bg-light border mt-2 layout-bg-border layout-padding">
            <Col sm={12}>
              <Row className="mb-2 col-btn-reportes">
                <Nav tabs>
                  <Col xs={12} className="text-center">
                    <Label className="label-bold-roboto">MENU</Label>
                  </Col>
                  {usr_perfil === "1" ? (
                    <Col className="btn-layout mt-2 btn-reporte_x2" xs ={4} sm={3} md={2}>
                      <NavItem className="text-center">
                        <NavLink tag={RRNavLink} to="/user/company" className="font-w-bold  menu-l">
                          <Label>Compañia</Label>
                          <img src={FACTORY_ICON} className="img-btn-layout" alt="..." />
                        </NavLink>
                      </NavItem>
                    </Col>
                  ) : null}
                  {usr_ajustes === "1" ? (
                    <Col className="btn-layout mt-2 btn-reporte_x2" xs ={4} sm={3} md={2}>
                      <NavItem className="text-center">
                        <NavLink
                          tag={RRNavLink}
                          to="/user/configuracion"
                          className="font-w-bold  menu-l"
                        >
                          <Label>Configuración</Label>
                          <img src={SETTING_IMAGE} className="img-btn-layout" alt="..." />
                        </NavLink>
                      </NavItem>
                    </Col>
                  ) : null}
                  {usr_factura === "1" ? (
                    <Col className="btn-layout mt-2 btn-reporte_x2" xs ={4} sm={3} md={2}>
                      <NavItem className="text-center">
                        <NavLink tag={RRNavLink} to="/user/factura" className="font-w-bold  menu-l">
                          <Label>Factura</Label>
                          <img src={CASH_REGISTER_IMAGE} className="img-btn-layout" alt="..." />
                        </NavLink>
                      </NavItem>
                    </Col>
                  ) : null}
                  {usr_inventario === "1" ? (
                    <Col className="btn-layout mt-2 btn-reporte_x2" xs ={4} sm={3} md={2}>
                      <NavItem className="text-center">
                        <NavLink
                          tag={RRNavLink}
                          to="/user/inventario"
                          className="font-w-bold  menu-l"
                        >
                          <Label>Inventario</Label>
                          <img src={INVENTARIO_IMAGE} className="img-btn-layout" alt="..." />
                        </NavLink>
                      </NavItem>
                    </Col>
                  ) : null}
                  {usr_cotizacion === "1" ? (
                    <Col className="btn-layout mt-2 btn-reporte_x2" xs ={4} sm={3} md={2}>
                      <NavItem className="text-center">
                        <NavLink
                          tag={RRNavLink}
                          to="/user/cotizacion"
                          className="font-w-bold  menu-l"
                        >
                          <Label>Cotizaciones</Label>
                          <img src={COTIZACION_IMAGE} className="img-btn-layout" alt="..." />
                        </NavLink>
                      </NavItem>
                    </Col>
                  ) : null}
                  {usr_clientes === "1" ? (
                    <Col className="btn-layout mt-2 btn-reporte_x2" xs ={4} sm={3} md={2}>
                      <NavItem className="text-center">
                        <NavLink
                          tag={RRNavLink}
                          to="/user/clientes"
                          className="font-w-bold  menu-l"
                        >
                          <Label>Contactos</Label>
                          <img src={CLIENTS_IMAGE} className="img-btn-layout" alt="..." />
                        </NavLink>
                      </NavItem>
                    </Col>
                  ) : null}
                  {usr_articulo === "1" ? (
                    <Col className="btn-layout mt-2 btn-reporte_x2" xs ={4} sm={3} md={2}>
                      <NavItem className="text-center">
                        <NavLink
                          tag={RRNavLink}
                          to="/user/articulos"
                          className="font-w-bold  menu-l"
                        >
                          <Label>Articulos</Label>
                          <img src={ARTICULOS_IMAGE} className="img-btn-layout" alt="..." />
                        </NavLink>
                      </NavItem>
                    </Col>
                  ) : null}
                  {usr_reporte === "1" ? (
                    <Col className="btn-layout mt-2 btn-reporte_x2" xs ={4} sm={3} md={2}>
                      <NavItem className="text-center">
                        <NavLink tag={RRNavLink} to="/user/reporte" className="font-w-bold  menu-l">
                          <Label>Reportes</Label>
                          <img src={REPORTE_IMAGE} className="img-btn-layout" alt="..." />
                        </NavLink>
                      </NavItem>
                    </Col>
                  ) : null}
                  {usr_gastos === "1" ? (
                    <Col className="btn-layout mt-2 btn-reporte_x2" xs ={4}  sm={3} md={2}>
                      <NavItem className="text-center">
                        <NavLink tag={RRNavLink} to="/user/gastos" className="font-w-bold  menu-l">
                          <Label>Cuentas por cobrar</Label>
                          <img src={MONEY_PAY} className="img-btn-layout" alt="..." />
                        </NavLink>
                      </NavItem>
                    </Col>
                  ) : null}
                  <Col className="btn-layout mt-2" xs ={4} sm={3} md={2}>
                    <NavItem
                      className="text-center"
                      onClick={() => {
                        quitToken();
                        document.location.href = "/";
                      }}
                    >
                      <NavLink className="font-w-bold  menu-l">
                        <Label>SALIR </Label>{" "}
                        <img
                          src={EXIT_IMAGE}
                          className="img-btn-layout"
                          alt="..."
                        />
                      </NavLink>
                    </NavItem>
                  </Col>
                </Nav>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col xs={8} sm={8} md={12}>
              <Label className="label-layout">Vendedor : {usr_nombre}</Label>
            </Col>
            <Col xs={4} sm={4} md={2}>
              <Label className="label-layout">
                {cajaData !== undefined ? cajaData.caj_descripcion : ""}{" "}
              </Label>
            </Col>
            <Col xs={12} sm={6}>
              <Label className="label-layout">
                Caducidad de licencia : {moment(dataCompania.ini_fecha).add(1, 'year').format("YYYY-MM-DD")}
              </Label>
            </Col>
            <Col xs={12} sm={6}>
              <Label className="label-layout">
                Folios disponibles : {dataFolios !== undefined? dataFolios.foliosTotalesDisponibles:""}
              </Label>
            </Col>
            <Col xs={12} sm={6}>
              <Label className="label-layout">
                Fecha de folios : {dataFolios !== undefined? dataFolios.fechaLicencia:""}
              </Label>
            </Col>

            <Col xs={12} sm={12} md={12} className="text-center">
              <Label className="label-layout">
                {dataCompania.com_nombre + " / " + dataCompania.com_alias}
              </Label>
            </Col>
          </Row>
          <Outlet />

          <footer className="footer-default text-center">
            <a href="https://mtechnologypanama.com/home/info" target="_blank" rel="noreferrer">
              {" "}
              wwww.mtechnologypanama.com
            </a>
          </footer>
        </Container>
      </React.Fragment>
    );
  }
};
export default Layout;
